import { SubSection } from "./fundCardHelpers";
import { InfoRow } from "../UI";

export default function AgentTab({ fund, cs }) {
  if (!fund.agent) return null;
  return (
    <SubSection title="סוכן / מיופה כוח" color={cs.accent}>
      <InfoRow label="שם סוכן" value={fund.agent.name} bold />
      <InfoRow label="מספר סוכן" value={fund.agent.number} />
      <InfoRow label="ת.ז. סוכן" value={fund.agent.id} />
      <InfoRow label="מינוי מתאריך" value={fund.agent.startDate} />
      <InfoRow label="תוקף ייפוי כוח" value={fund.agent.endDate} />
    </SubSection>
  );
}
